'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { usePageChecker } from '@/shared/hooks/usePageChecker';
import { useMenu } from '@/shared/providers/menu-provider';
import { useI18n } from '@locales/client';
import { useIsUserLoading, useAppInstalled } from '@/shared/providers/user-provider/use-user';
import { StyledPromoButton, StyledIcon} from './styles';


export const AppInstallTrigger = () => {
  const { isOpen, isViewMenu, isReady } = useMenu();
  const t = useI18n();
  const router = useRouter();
  const isUserLoading = useIsUserLoading();
  const appInstalled = useAppInstalled();
  const { isCurrentPage } = usePageChecker();
  const isInstallationGuide = isCurrentPage('/installation-guide');
  const isVisible = !isOpen && isViewMenu && isReady && !isUserLoading && !appInstalled && !isInstallationGuide;
  const handleClick = () =>{
    if(!isInstallationGuide){
      router.push('/installation-guide');
    }
  }

  return (
    <StyledPromoButton 
      onClick={handleClick} 
      variant="gray" 
      $isView={isVisible}
    >
      <StyledIcon
        src="/images/Installation-guide/android-icon.svg"
        alt="android-icon"
      />
      <BodyTextMediumC>
        {t('application.mobile_app_title', { brand: '' })}
      </BodyTextMediumC>
    </StyledPromoButton>
  );
};
